import React, { Component } from 'react';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import Help32 from '@carbon/icons-react/lib/help--filled/32';
import Request32 from '@carbon/icons-react/lib/request-quote/32';
import DocumentView32 from '@carbon/icons-react/lib/document--view/32';
import PlayFilled64 from '@carbon/icons-react/lib/play--filled/32';
import Events32 from '@carbon/icons-react/lib/events/32';
import Launch32 from '@carbon/icons-react/lib/launch/16';

export class Support extends Component {
  constructor(props) {
    super(props);
  }
  static displayName = Support.name;

  render() {
    return (
      <>
        <PageBreadCrumb linkTo={'/'} linkText="Home" titleLeft="Support" />
        <div className="mainContainer">
          <div className="bx--col-lg-12">
            <h3 className="description-page">Do you need help?</h3>
            <div className="supportMargin">
              <div class="bx--row">
                <div className="supportTitle">
                  <a
                    className="suppTitle"
                    href="https://saipem.sharepoint.com/sites/HSE-PrometheusEvolution-NTTDATA/Shared%20Documents/General/InSight%20User%20Guide"
                  > {/* RITM0634723 */}
                    <DocumentView32 />
                  </a>
                </div>
                <div class="supportText">
                  Read the User Guide to best learn every aspect of InSight!
                  <a
                    className="suppTitle"
                    // href="https://saipem.sharepoint.com/sites/HSE-PrometheusEvolution-NTTDATA/Shared%20Documents/General/InSight%20User%20Guide/Saipem%20InSight%20-%20User%20Guide%20v.7.0.pptx?d=w271415b013bb472abc90c42a70804e2b&csf=1&web=1&e=tleOjh"
                    href="https://saipem.sharepoint.com/sites/HSE-PrometheusEvolution-NTTDATA/Shared%20Documents/General/InSight%20User%20Guide"
                  >
                    {' '}
                    Go to User Guide <Launch32 />
                  </a>
                </div>
              </div>

              <div class="bx--row">
                <div className="supportTitle">
                  <a
                    className="suppTitle"
                    href="https://web.microsoftstream.com/group/e8f7246a-5f51-478e-8a42-bb11a03e1d9a?view=videos"
                  >
                    <PlayFilled64 />
                  </a>
                </div>
                <div class="supportText">
                  Watch the video tutorials to understand how to best interact with InSight!
                  <a
                    className="suppTitle"
                    href="https://web.microsoftstream.com/group/e8f7246a-5f51-478e-8a42-bb11a03e1d9a?view=videos"
                  >
                    {' '}
                    Go to Video Tutorial <Launch32 />{' '}
                  </a>
                </div>
              </div>

              {/* <div class="bx--row">
                <div className="supportTitle">
                  <a className="suppTitle" href="">
                    <Help32 />
                  </a>
                </div>
                <div class="supportText">
                  Please, visit the Frequently Asked Question!
                  <a className="suppTitle" href="">
                    {' '}
                    Go to FAQ <Launch32 />
                  </a>
                </div>
              </div> */}

              <div class="bx--row">
                <div className="supportTitle">
                  <a className="suppTitle" href="https://saipem.sharepoint.com/sites/InSight-Support/Lists/RequestForm/NewForm.aspx"> {/* RITM0634723  */}
                    <Request32 />
                  </a>
                </div>
                <div class="supportText">
                  If Video Tutorial were not useful , please submit your request!
                  <a
                    className="suppTitle"
                    href="https://saipem.sharepoint.com/sites/InSight-Support/Lists/RequestForm/NewForm.aspx"
                  >
                    {' '}
                    Go to Request Support <Launch32 />{' '}
                  </a>
                </div>
              </div>

              {/* RITM0634723 */}
              {/* RITM0932309 */}
              <div class="bx--row">
                <div className="supportTitle">
                  <a 
                    className="suppTitle" 
                    href="https://saipem.sharepoint.com/sites/HSEsite/New%20HSE%20Site/Corporate%20HSE/InSight/Shared%20Documents/InSight%20Responsibility%20Matrix/InSight%20-%20Responsibility%20Matrix.pdf?CT=1702372489869&OR=Outlook-Body&CID=5CE7D9EB-9EC0-4D34-AFF0-E05952F3A58F&WSL=1"
                  >
                    <img width="32px" height="32px" src="/images/icon-responsibilityMatrix.svg" />
                  </a>
                </div>
                <div class="supportText">
                  Take a look at the Insight responsibility matrix!
                  <a
                    className="suppTitle"
                    href="https://saipem.sharepoint.com/sites/HSEsite/New%20HSE%20Site/Corporate%20HSE/InSight/Shared%20Documents/InSight%20Responsibility%20Matrix/InSight%20-%20Responsibility%20Matrix.pdf?CT=1702372489869&OR=Outlook-Body&CID=5CE7D9EB-9EC0-4D34-AFF0-E05952F3A58F&WSL=1"
                  >
                    {' '}
                    Go to Insight Responsibility Matrix <Launch32 />{' '}
                  </a>
                </div>
              </div>
              <div class="bx--row">
                <div className="supportTitle">
                  <a 
                    className="suppTitle" 
                    href="https://saipem.sharepoint.com/sites/HSEsite/New%20HSE%20Site/Corporate%20HSE/InSight/SitePages/Home.aspx?RootFolder=%2Fsites%2FHSEsite%2FNew%20HSE%20Site%2FCorporate%20HSE%2FInSight%2FShared%20Documents%2FTraining%20schedule&FolderCTID=0x0120003C7E13B5DF8DEF4794CE9069AB8C601A&View=%7B66BCB0EF%2D754E%2D467B%2DB0B4%2DA76FBADC0E3C%7D"
                  >
                    <img width="32px" height="32px" src="/images/icon-trainingSchedule.svg" />
                  </a>
                </div>
                <div class="supportText">
                  Take a look at the Training schedule!
                  <a
                    className="suppTitle"
                    href="https://saipem.sharepoint.com/sites/HSEsite/New%20HSE%20Site/Corporate%20HSE/InSight/SitePages/Home.aspx?RootFolder=%2Fsites%2FHSEsite%2FNew%20HSE%20Site%2FCorporate%20HSE%2FInSight%2FShared%20Documents%2FTraining%20schedule&FolderCTID=0x0120003C7E13B5DF8DEF4794CE9069AB8C601A&View=%7B66BCB0EF%2D754E%2D467B%2DB0B4%2DA76FBADC0E3C%7D"
                  >
                    {' '}
                    Go to training schedule <Launch32 />{' '}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
